(function($, document, window, lq) {
	//'use strict';
	
	lq.tableau = (function(option){

        function adapteTableau(element) {
            
            /*var tableau$ = $(element);
            var tableauBoutonPlus$ = $(element).find('.tableauBoutonPlus');

            if($(element).data('nb-element-ordinateur-max') < $(element).find('.ligne').length){
                $(element).find('.plusWrapDesktop').removeClass('init');
            }
            if($(element).data('nb-elemente-mobile-max') < $(element).find('.ligne').length){
                $(element).find('.plusWrapMobile').removeClass('init');
            }

            var handler = {
                mobile: function () {
                    var button$ = $(this);

                    tableau$.find('.ligne:not(".mobile")')
                        .addClass('mobile');

                    if (!tableau$.find('.ligne:not(".mobile")').length) {
                        button$.parent().remove();
                    }
                },
                desktop: function () {
                    var button$ = $(this);

                    tableau$.find('.ligne:not(".desktop")')
                        .addClass('desktop');

                    if (!tableau$.find('.ligne:not(".desktop")').length) {
                        button$.parent().remove();
                    }
                }
            };*/

            tableauBoutonPlus$.on('click', function () {
                //handler[$(this).data().buttonPlus].call(this);
            });

        }
        
        // Accès public aux méthodes
        return{
        	tableau: function(){
        		/*if($('.tableau').length > 0){
        			
                }*/
                //$.each('.tableau',adapteTableau());
                $('.tableau .table-vertical').each(function (index, element) {
                    adapteTableau(element);
                });
        	}
        
        };


    })();
    // Update global scope lq namespace
    window.lq = lq;

    //--> Auto trigger all self implemented functionalities on document ready
    lq.load.push(
        "lq.tableau", [
            'tableau'
        ]
    );

}($, document, window, (window.lq || {})));